import {ChangeDetectorRef, Component, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {of, Subject} from 'rxjs';
import {catchError, takeUntil} from 'rxjs/operators';
import {SpecificationsService} from "../../core/services/specifications.service";
import {SpecificationsBuyer} from "../../core/interfaces/specifications.interface";


@Component({
    selector: 'app-specifications-buyer-select',
    // exportAs: 'ngModel', disabled until finding out how to replace #project="ngModel" attribute of <app-project-select> to render validation errors via <span *ngIf="project.invalid && (project.dirty || project.touched)">
    templateUrl: './specifications-buyer-select.component.html',
    styleUrls: ['./specifications-buyer-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SpecificationsBuyerSelectComponent),
            multi: true
        }
    ]
})

export class SpecificationsBuyerSelectComponent implements OnInit, OnDestroy, ControlValueAccessor {
    @Input() parent: number = null;
    @Input() placeholder: string = 'Select an item';
    @Input() clearable: boolean = true;
    @Input() searchable: boolean = true;
    _disabled: boolean = false;

    items: SpecificationsBuyer[] = [];
    loading: boolean = false;
    value: any = null;

    private destroy$ = new Subject<void>();
    private onChange = (value: any) => {};
    private onTouched = () => {};

    constructor(private service: SpecificationsService, private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        // Watch for parent changes
        this.loadItems();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnChanges(changes: any) {
        if (changes.parent) {
            this.loadItems();
            // Clear selection when parent changes
            if (this.value) {
                this.value = null;
                this.onChange(null);
            }
        }
    }

    private loadItems() {
        // Clear items immediately
        this.items = [];

        if (!this.parent) {
            return;
        }

        this.loading = true;
        this.service.getBuyerList(this.parent)
            .pipe(
                takeUntil(this.destroy$),
                catchError(error => {
                    console.error('Error loading items:', error);
                    return of([]); // Return empty array on error
                })
            )
            .subscribe(data => {
                this.items = data.data || [];
                this.loading = false;
            });
    }

    onSelectionChange(value: any) {
        this.value = value;
        this.onChange(value);
        this.onTouched();
    }

    // ControlValueAccessor implementation
    writeValue(value: any): void {
        this.value = value;
    }

    registerOnChange(fn: (value: any) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this._disabled = isDisabled;
    }

    @Input() set disabled(disabled: boolean) {
        setTimeout(() => {
            this.setDisabledState(disabled);
        }, 0)
    };

}